import { SEARCH_TAGS_SUCCESS, CLEAR_TAGS } from 'actionTypes';

const initialState = {
  searchText: '',
  results: [],
};

export default function tagSearchResultsReducer(state = initialState, action) {
  const { type, searchText, normalizedData } = action;
  switch (type) {
    case SEARCH_TAGS_SUCCESS:
      return {
        searchText,
        results: normalizedData.result,
      };
    case CLEAR_TAGS:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tagSearchResultsReducer.js